import { Button } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { importUsers } from "apis/import";
import React, { useCallback, useState } from "react";
import CSVReader from "react-csv-reader";
import { message } from "antd";
import { IMPORT_STATUS } from "constants/types";

export const Users: React.FC<IResourceComponentsProps> = () => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleImport = useCallback(async () => {
    setLoading(true);
    const res = await importUsers(data);
    if (res?.type === IMPORT_STATUS.SUCCESS) {
      message.success(res?.message || "Import users successfully.");
    } else if (res?.type === IMPORT_STATUS.WARNING) {
      message.warning(
        `Warning : ${(res?.existedUsers || []).length} users have already exist `,
        10
      );
    } else {
      message.error("Something went wrong.");
    }
    setLoading(false);
  }, [data]);

  return (
    <div style={{ marginTop: "40px" }}>
      <CSVReader
        onFileLoaded={async (data, fileInfo, originalFile) => {
          const cols = data[0];
          let objectData: any[] = [];
          data.slice(1).forEach((item) => {
            let obj: any = {};
            cols.forEach((col: any, index: any) => {
              obj[col] = item[index];
            });
            objectData.push(obj);
          });
          setData(objectData);
        }}
      />
      {data && (
        <Button
          style={{ marginTop: "40px" }}
          loading={isLoading}
          onClick={handleImport}
        >
          Import
        </Button>
      )}
    </div>
  );
};
